import { jsxs, jsx } from "react/jsx-runtime";
import Socials from "../../../buttons/Socials/Socials.js";
import Brand from "../../../graphics/Brand/Brand.js";
import "../../../graphics/Brand/items/IdaLogo.js";
import "../../../graphics/Brand/items/MitIdaLogo.js";
import "../../../graphics/Brand/items/IdaForsikringLogo.js";
import Group from "../../../layout/Group/Group.js";
import Paragraph from "../../../typography/Paragraph/Paragraph.js";
import { useMatches, rem } from "@mantine/core";
import { F as FooterStyles } from "../../../../Footer.module-DJ70l-Jq.js";
const BrandBar = (props) => {
  const { logo, ...rest } = props;
  const smallLogo = useMatches({ base: true, xs: false });
  const address = {
    street: "Kalvebod Brygge 31-33",
    city: "1780 København V"
  };
  return /* @__PURE__ */ jsxs(Group, { className: FooterStyles.brandBar, spacing: rem("56px"), children: [
    /* @__PURE__ */ jsxs(Group, { className: FooterStyles.brand, spacing: rem("16px"), children: [
      /* @__PURE__ */ jsx(
        Brand,
        {
          name: logo,
          href: "/",
          color: "neutral",
          width: smallLogo ? 86 : 98,
          height: smallLogo ? 34 : 38
        }
      ),
      /* @__PURE__ */ jsxs(Group, { className: FooterStyles.address, direction: "column", spacing: 0, children: [
        /* @__PURE__ */ jsx(
          Paragraph,
          {
            text: address.street,
            className: FooterStyles.addressItem,
            scale: 0.875,
            variant: "neutral"
          }
        ),
        /* @__PURE__ */ jsx(
          Paragraph,
          {
            text: address.city,
            className: FooterStyles.addressItem,
            scale: 0.875,
            variant: "neutral"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx(Socials, { visibleFrom: "xs", ...rest, spacing: rem("32px"), size: "lg", variant: "neutral" })
  ] });
};
export {
  BrandBar as default
};
